import request, { ResponseData } from '@/utils/request'
import { LoginResult } from '@/models/user'

export interface LoginParams {
  username: string
  password: string
}

// 获取用户信息
export async function fetchUserInfo(): Promise<ResponseData<LoginResult>> {
  return request('/api/v1/users/me', {
    method: 'get',
  })
}

// 登录
export async function login(params: LoginParams): Promise<ResponseData<LoginResult>> {
  // console.log('params', params)
  return request('/api/v1/users/login', {
    method: 'post',
    data: params,
    hideErrorMessage: true,
  })
}

// 登出
export async function logout(): Promise<ResponseData<null>> {
  return request('/api/v1/users/logout', {
    method: 'post',
  })
}

// 修改账号名
export async function updateUserName(params: UpdatePasswordParams): Promise<ResponseData<null>> {
  return request('/api/v1/users/tenant_modify', {
    method: 'post',
    data: params,
  })
}

export interface UpdatePasswordParams {
  old_password: string
  new_password: string
}

// 修改密码
export async function updatePassword(params: UpdatePasswordParams): Promise<ResponseData<null>> {
  return request('/api/v1/users/changepassword', {
    method: 'post',
    data: params,
  })
}

//  切换平台
export async function switchPlatform(params: any): Promise<ResponseData<null>> {
  return request('/api/v1/users/switch_platform', {
    method: 'post',
    data: params,
  })
}

// 行业类目查询
export async function industryCategory(): Promise<ResponseData<null>> {
  return request('/api/v1/users/industry_category', {
    method: 'get',
  })
}

export async function initUserOnce(params: any): Promise<ResponseData<null>> {
  return request('/api/v1/users/init_user_once', {
    method: 'post',
    data: params,
  })
}

export async function bindXHMC(): Promise<ResponseData<null>> {
  return request('/api/v1/users/mc_bind', {
    method: 'post',
  })
}

export async function resetPass(params: { account_id: string; password: string }) {
  return request('/api/v1/users/reset', {
    method: 'post',
    data: params,
  })
}

export async function getUcToken(params): Promise<ResponseData<null>> {
  return request('/api/v1/users/get_uc_token', {
    method: 'post',
    data: params,
  })
}

export async function mcUnbind(): Promise<ResponseData<null>> {
  return request('/api/v1/users/mc_unbind', {
    method: 'post',
  })
}

export async function onlineUsers(): Promise<ResponseData<null>> {
  return request('/api/v1/users/online_users', {
    method: 'post',
  })
}
export async function presetTask(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/task/preset_task', {
    method: 'post',
    data: params,
  })
}
// 调用机器人接口获取token
export async function fetchCgateToken(params): Promise<ResponseData<null>> {
  return request('/api/v1/users/cgate_auth', {
    method: 'post',
    data: params,
  })
}
// 绑定多策id
export async function agentBind(params): Promise<ResponseData<null>> {
  return request('/api/v1/users/agent_bind', {
    method: 'post',
    data: params,
  })
}

// 首页数据
export async function fetchTrainData(): Promise<ResponseData<null>> {
  return request('/api/v1/users//train_data', {
    method: 'post',
  })
}
// 查询训练场插件
export async function queryTools(params) {
  return request('/api/v1/training/tool/pri_plugins', {
    method: 'get',
    data: params,
  })
}

// 购买应用包后刷数据
export async function pluginCal(params) {
  return request('/api/v1/sys/plugin_call/sync', {
    method: 'post',
    data: params,
  })
}

// 获取企业元数据
export function getMetadata(): Promise<ResponseData<null>> {
  return request('/api/v1/enterprise/metadata/get', {
    method: 'get',
  })
}

// 获取用户所属的用户组
export function getGroups(): Promise<ResponseData<null>> {
  return request('/api/v1/users/get_groups', {
    method: 'post',
    data: {},
  })
}
